export const MisSolicitudesHeaders = [
  {
    text: 'Título',
    value: 'titulo',
    align: 'center',
  },
  {
    text: 'Nº Solicitud',
    value: 'num_solicitud',
    align: 'center',
  },
  {
    text: 'Patente',
    value: 'patente',
    align: 'center',
  },
  {
    text: 'Serie',
    value: 'serie',
    align: 'center',
  },
  {
    text: 'Razón Social',
    value: 'razon_social',
    align: 'center',
  },
  {
    text: 'RUT',
    value: 'rut',
    align: 'center',
  },
  {
    text: 'Ejecutivo',
    value: 'ejecutivo',
    align: 'center',
  },
  {
    text: 'Tipo',
    value: 'tipo',
    align: 'center',
  },
  {
    text: 'Fecha creación',
    value: 'fecha_creacion',
    align: 'center',
  },
  {
    text: 'Descripción',
    value: 'descripcion',
    align: 'center',
  },
  {
    text: 'Estado',
    value: 'estado',
    align: 'center',
  },
  {
    text: 'Acciones',
    value: 'actions',
    align: 'center',
  },
];
